import { Component } from '@angular/core';

@Component({
  selector: 'csgofast-advertisements',
  templateUrl: './advertisements.component.html',
  styleUrls: ['./advertisements.component.scss'],
})
export class AdvertisementsComponent {}
